import { render, staticRenderFns } from "./Teamperformance.vue?vue&type=template&id=a8bafab4&scoped=true"
import script from "./Teamperformance.vue?vue&type=script&lang=js"
export * from "./Teamperformance.vue?vue&type=script&lang=js"
import style0 from "./Teamperformance.vue?vue&type=style&index=0&id=a8bafab4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bafab4",
  null
  
)

export default component.exports